import type { Filter } from '../../types/filter.types';

type Op = 'and' | 'or';

const flatten = (op: Op, f: Filter): Filter[] => (op in f && f[op]?.operands ? f[op].operands : [f]);

export const merge = (op: Op, ...filters: Filter[]): Filter => ({
  [op]: { operands: filters.flatMap(f => flatten(op, f)) },
});

export const mergeAnd = (...filters: Filter[]) => merge('and', ...filters);
export const mergeOr = (...filters: Filter[]) => merge('or', ...filters);
